// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__34Vra","footer":"ReportModalFilter_footer__2hHvE"};